import useCardStack from "@pathwright/ui/src/components/card/useCardStack"
import { LinkContext } from "@pathwright/ui/src/components/link/Link"
import Tabs from "@pathwright/ui/src/components/tab/Tabs"
import React from "react"
import styled from "styled-components"
import { usePathwrightContext } from "../../../pathwright/PathwrightContext"
import ProfileCard from "../../../profile/ProfileCard"
import { useReviewContext } from "../../state/ReviewContextProvider"
import { ProfilePanelSection } from "./sections/ContextStackSections"
import { InboxPanel, InboxPanelKey } from "./usePanels"

const CardsStackContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  z-index: 1000000000;
  background-color: white;
  width: 100%;
  max-height: calc(var(--vh) - 70px);
  border-radius: 20px;
  overflow: auto;

  .Card__Nav ~ * {
    max-height: calc(100% - 40px) !important;
  }

  .ProfileCard .ProfileCard__header {
    padding: 0 10px;
  }

  .ProfileCard .ProfileCard__header > div {
    margin-right: 10px !important;
  }

  .ProfileCard .ProfileCard__header .Avatar,
  .ProfileCard .ProfileCard__header .Avatar img {
    width: 50px !important;
    height: 50px !important;
    line-height: 50px !important;
  }
`

const TabContainer = styled.div`
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  position: relative;

  // we can't scroll in the review panel b/c it clips the richtext toolbar
  .Tabs__panels-container {
    overflow: auto;
  }

  .Tabs__tabs-container {
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);

    /* Hide tab if there's only 1 */
    .Tab:only-child {
      display: none;
    }

    .Tab {
      color: #999;
      font-weight: normal;
      border-bottom: 0px;
      &.Tab--active,
      &:hover {
        border-bottom: 0px;
        color: #000;
      }

      &.Tab--active {
        font-weight: bold;
      }
    }
  }
`

const InboxContextPanel = ({
  panels,
  onSelect,
  selectedPanel
}: {
  panels: InboxPanel[]
  onSelect: (panelKey: InboxPanelKey | null) => void
  selectedPanel?: InboxPanelKey | null
}) => {
  const { me } = usePathwrightContext()
  const { selected } = useReviewContext()

  const { cards, open } = useCardStack({
    component: ProfileCard,
    props: {
      title: "Profile",
      userId: selected?.user?.id,
      showTabs: ["registrations", "activity"]
    }
  })

  const openProfileCard =
    selected!.data.completion.user &&
    me.id !== selected!.data.completion.user?.id
      ? open
      : null

  return (
    <React.Fragment>
      <ProfilePanelSection item={selected!} onSelect={openProfileCard} />
      <TabContainer>
        <Tabs
          tabs={panels}
          selected={selectedPanel}
          onSelect={onSelect}
          mode="panel"
        />
      </TabContainer>
      {!!cards && (
        <LinkContext.Provider value={{ target: "_blank" }}>
          <CardsStackContainer>{cards}</CardsStackContainer>
        </LinkContext.Provider>
      )}
    </React.Fragment>
  )
}

export default InboxContextPanel
